import React, { Component } from 'react'
import Header from '../Header'
import './XIVw.css'

class XIVw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXIVw">
                    <p className="textXIVw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default XIVw